import { ModelUser, UserGroup, UserRole } from '~/models'

export function checkUserGroup(
  group: keyof typeof UserGroup,
  user: ModelUser | null
) {
  if (!user) {
    return false
  }
  if (group === UserGroup.companyAdmin) {
    if (user!.role === UserRole.managingBroker) {
      return true
    }
    return [
      UserGroup.superAdmin,
      UserGroup.organizationAdmin,
      UserGroup.companyAdmin,
    ].includes(user.group)
  } else if (group === UserGroup.organizationAdmin) {
    return [UserGroup.superAdmin, UserGroup.organizationAdmin].includes(
      user.group
    )
  } else if (group === UserGroup.superAdmin) {
    return user.group === UserGroup.superAdmin
  }
  return false
}
